import { CommonListData, NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel } from '../../utilitymodels/base.model';
import { ProstartDataModel } from '../prostart/prostart.model';
import { HeadersList, ListMetaModel, ListModel } from 'common/models/utilitymodels/list.model';

export class WelcomeModel extends BaseDataModel {
    videoList: ProstartDataModel[];
    errorModel: any[] = [];
}

export class WelcomeListingModel extends ListModel<WelcomeModel> {
    curruntSelectedVideo: any = {};
    testimonialList: any[] = [];
    testimonialFilterList: any[] = [];
    countList: any[] = [];
    countFilterList: any[] = [];
}

export class WelcomeMetaModel extends ListMetaModel<HeadersList> {
    showModal: boolean = false;
    constructor() {
        super('Welcome', '', true, CommonListData.rowPerPage, NavigateRoutes.welcome);
    }
    prepareHeaderList(): HeadersList[] {
        const headers: HeadersList[] = [];
        return headers;
    }

    initProperties(): any {
        const dataInfo = {
            isEditable: this.isEditable,
            recordPerPage: this.recordPerPage,
            listInfo: this.prepareHeaderList(),
            pointer: undefined,
            isSortOpen: false,
            isFilterOpen: false,
            showModal: this.showModal,
        };
        return dataInfo;
    }
}
